import axios from 'axios';
import env from '../config';
import store from '../store'
import curlirize from 'axios-curlirize';
curlirize(axios, (result, err) => {
    if (err) {
        console.log(result.command);
    }
});

function getCookie(cookieName) {
    const name = cookieName + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');

    for (let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i];
        while (cookie.charAt(0) === ' ') {
            cookie = cookie.substring(1);
        }
        if (cookie.indexOf(name) === 0) {
            return cookie.substring(name.length, cookie.length);
        }
    }

    return null;
}

axios.interceptors.request.use(
    config => {
        const csrftoken = getCookie('csrftoken');

        config.withCredentials = true;
        config.headers['Referer'] = 'https://serviskayit.viessmann.com.tr';
        config.headers['X-CSRFToken'] = csrftoken;

        // Sadece Content-Type belirtilmemişse JSON ata
        if (!(config.data instanceof FormData)) {
            config.headers['Content-Type'] = 'application/json';
        } else {
            // FormData için Content-Type'ı tamamen kaldır.
            // Browser boundary bilgisini kendisi ekler.
            delete config.headers['Content-Type'];
        }

        return config
    },
    error => Promise.reject(error)
);

axios.defaults.baseURL = env.API_BASE_URL;

export default axios